import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BackHeader } from "@/components/TopBar";
import { Spinner, EmptyState } from "@/components/common";
import { ListingCard } from "@/components/ListingCard";
import { PersonCard } from "@/components/PersonCard";
import { TribeCard } from "@/components/TribeCard";
import { Bookmark } from "lucide-react";

export default function Saved() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("listings");
  const load = () => api.get("/saved").then((r) => setData(r.data)).catch(() => setData({ listings: [], people: [], tribes: [], ids: [] }));
  useEffect(() => { load(); }, []);
  const onSave = () => load();

  const tabs = [["listings", "Rooms"], ["people", "People"], ["tribes", "Tribes"]];

  return (
    <div>
      <BackHeader title="Saved" />
      <div className="px-4 pt-4">
        <div className="mb-4 flex rounded-full bg-secondary p-1">
          {tabs.map(([id, label]) => (
            <button key={id} data-testid={`saved-tab-${id}`} onClick={() => setTab(id)} className={`flex-1 rounded-full py-2 text-sm font-bold transition-colors ${tab === id ? "bg-white text-ink shadow-soft" : "text-ink-soft"}`}>
              {label} {data ? `(${data[id].length})` : ""}
            </button>
          ))}
        </div>
        {data === null ? <Spinner /> : (
          <>
            {tab === "listings" && (data.listings.length ? <div className="space-y-5">{data.listings.map((l) => <ListingCard key={l.listing_id} listing={l} savedIds={data.ids} onSaveChange={onSave} />)}</div> : <EmptyState icon={Bookmark} title="No saved rooms" sub="Tap the heart on a room to save it." />)}
            {tab === "people" && (data.people.length ? <div className="grid grid-cols-2 gap-4">{data.people.map((p) => <PersonCard key={p.user_id} person={p} savedIds={data.ids} onSaveChange={onSave} />)}</div> : <EmptyState icon={Bookmark} title="No saved people" sub="Save profiles you'd like to revisit." />)}
            {tab === "tribes" && (data.tribes.length ? <div className="space-y-4">{data.tribes.map((t) => <TribeCard key={t.tribe_id} tribe={t} />)}</div> : <EmptyState icon={Bookmark} title="No saved tribes" sub="Save tribes to track them." />)}
          </>
        )}
      </div>
    </div>
  );
}
